import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import CAStore from "../../Store/TemplateStore/template.store";

import {
  storeApp,
  storeSettingsDefaults,
} from "../../Store/TemplateStore/template.action";

import Header from "../../components/Header";
import { API_URLS } from "../../network/appUrls";
import { getadvanceSettings } from "../../network/cipAPI";

import { extractPlantId } from "../../utils/Utils";

import cleaningIcon from "../../assets/cleaning_advisor_uf_logo.svg";
import replacementIcon from "../../assets/replacement_advisor_logo.svg";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";
import Footer from "../../common/footer";

import "./index.scss";

export const store = CAStore;
//const isLocalhost = window.location.hostname === "localhost";
//const basePath = isLocalhost ? "/" : "/roadvisor/";
//const basePath = isLocalhost ? "/" : window.location.origin;
const basePath = API_URLS.basePath; //isLocalhost ? "/" : window.location.origin;
const Home = () => {
  const { t, i18n } = useTranslation();
  const plantId = extractPlantId();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(storeApp(null));
    // Fetch and dispatch advanced settings
    const fetchAndStoreAdvancedSettings = async () => {
      try {
        const response = await getadvanceSettings();
        if (response && response.data) {
          dispatch(storeSettingsDefaults(response.data));
        }
      } catch (error) {
        // Optionally handle error
        console.log("Error fetching advanced settings: ", error);
      }
    };
    fetchAndStoreAdvancedSettings();
  }, [dispatch]);
  return (
    <>
      <div className="container-main">
        <Header
        // setCleaningAdvisorHome={setCleaningAdvisorHome}
        // setReplacementAdvisorHome={setReplacementAdvisorHome}
        />
        <div className="main-container">
          <div className="content-container">
            <div className="centered-div descriptionText">
              <div className="heading-text ">
                {t("appHome.roOperationsAdvisor")}
              </div>
              <div
                className="marginBtm20"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <span style={{ flex: 1 }}>
                  {t("appHome.roOperationsAdvisorDescription")}
                </span>
                <div className="margin-left-20">
                  <PopoverText
                    descriptor={<img src={InfoIconGreen} alt="icon" />}
                    descriptionText={t("appHome.cleaningAdvisorSelection")}
                  />
                </div>
              </div>

              <div className="marginBtm20">
                {t("appHome.roAdvisorComponent")}
              </div>
              <div className="heading-text margin-left-60 ">
                {t("appHome.roAdvisor")}
              </div>

              <div className="flex-ai-center marginBtm20">
                <img className="img" src={cleaningIcon}></img>
                <div className=" margin-left-10 ">
                  {t("appHome.roAdvisorDescription")}
                </div>
              </div>
              <div className="text-right pointer">
                {" "}
                <Link
                  to={`${basePath}cleaningAdvisorHome?plantId=${plantId}`}
                  className="descriptionText"
                >
                  {t("appHome.gotoApp")}
                </Link>
              </div>
              <div className="margin-left-60 marginBtm10">
                <span className="heading-text">
                  {t("appHome.roReplacementAdvisor")}
                </span>
                <span className="descriptionGreyTextComingSoon margin-left-10">
                  {t("appHome.comingSoon")}
                </span>{" "}
              </div>

              <div className="flex-ai-center">
                <img className="img" src={replacementIcon}></img>
                <div className=" margin-left-10 ">
                  {t("appHome.roReplacementAdvisorDescription")}
                </div>
              </div>
              <div className="text-right pointer">
                {" "}
                <Link
                  to={`${basePath}lifetimeAdvisorHome?plantId=${plantId}`}
                  className="descriptionGreyText"
                  onClick={(e) => e.preventDefault()} // disable link to lifetime advisor temporarily
                >
                  {t("appHome.gotoApp")}
                </Link>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
